import { createApp } from 'vue'
import FuelCost from './FuelCost.vue'
import './assets/global.css'

createApp(FuelCost).mount('#fuelCost')
